// extracted by mini-css-extract-plugin
export default {"form":"CorrectionForm_form__TeEXR","selectDivider":"CorrectionForm_selectDivider__vLN0v","selectButton":"CorrectionForm_selectButton__qvr0z"};